import { FC, PropsWithChildren, ReactElement } from 'react'

import { ValkLogo } from '@/components'
import { LanguageSelector } from '@/compositions'
import { ConnectedCacheBuster } from '@/connectors'

import packageJson from '../../../package.json'

import './Page.scss'

interface PageProps {
    isOffline?: boolean
    showLanguageSelector?: boolean
    className?: string
}

export const Page: FC<PropsWithChildren<PageProps>> = ({
    isOffline,
    showLanguageSelector = false,
    children,
    className = '',
}): ReactElement => (
    <div className={`page ${className}`}>
        <ValkLogo className="page__valk-logo" />

        {children}

        <div className="page__version-number">
            {packageJson.version}
            {isOffline && '*'}
        </div>

        {showLanguageSelector && (
            <LanguageSelector className="page__language-selector" />
        )}

        <ConnectedCacheBuster />
    </div>
)
